import { Alert, Platform, type AlertButton } from "react-native";

/**
 * react-native-web's Alert.alert is a no-op stub: it shows nothing and never
 * runs a button's onPress, so on the web every error message and every
 * "are you sure?" step would silently do nothing. Replace it with the
 * browser's own dialogs. A single button is a notice; two or more is a
 * confirmation where OK runs the first non-cancel button and Cancel runs the
 * cancel button.
 */
function webAlert(title: string, message?: string, buttons?: AlertButton[]) {
  const text = message ? `${title}\n\n${message}` : title;
  const options = buttons ?? [];

  if (options.length < 2) {
    window.alert(text);
    options[0]?.onPress?.();
    return;
  }

  const cancel = options.find((button) => button.style === "cancel");
  const confirm = options.find((button) => button !== cancel) ?? options[0];
  if (window.confirm(text)) confirm?.onPress?.();
  else cancel?.onPress?.();
}

if (Platform.OS === "web" && typeof window !== "undefined") {
  Alert.alert = webAlert;
}
